<template>
  <div class="burger" :class="{ open: open }">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>
<script>
// AUTHOR : https://codepen.io/designcouch/pen/Atyop
export default {
  name: "BurgerIcon",
  props: {
    open: { type: Boolean }
  }
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
$color: $black;
$width: 30px;
$height: 15px;
.burger {
  width: $width;
  height: $height;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;
}

.burger span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: $color;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
}

/* Icon 3 */

.burger span:nth-child(1) {
  top: 0px;
}

.burger span:nth-child(2),
.burger span:nth-child(3) {
  top: $height / 2;
}

.burger span:nth-child(4) {
  top: $height;
}

.burger.open span:nth-child(1) {
  top: $height / 2;
  width: 0%;
  left: 50%;
}

.burger.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

.burger.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.burger.open span:nth-child(4) {
  top: $height / 2;
  width: 0%;
  left: 50%;
}
</style>
